@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.check-connection {
  font-size: 13px;
  line-height: 16px;
  padding: 10px;
  background: @print-modal--content-printer-hints--background-color;
}

.install-shipstation-connect {
  font-size: 13px;
  line-height: 16px;
  padding: 10px;
  background: @print-modal--content-printer-hints--background-color;
  text-align: center;

  > .install-message {
    &:after {
      content: ' ';
    }
  }
}

.install-shipstation-connect-button {
  font-size: 13px;
  line-height: 16px;
}
